export enum ERROR_CODES {
  GENERIC = 'SOMETHING_WENT_WRONG',
  INDALID_RESPONSE = 'INVALID_RESPONSE',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  BAD_REQUEST = 'BAD_REQUEST',
  SERVER_RESPONSE_5XX = 'SERVER_RESPONSE_5XX',
  UNKNOWN = 'UNKNOWN'
}
